import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'


export type PostFilter = 'recent' | 'most-viewed' | 'all' | 'services' | 'salon-products' | 'store-products' | 'products';

const getUsersPosts = async (filter: PostFilter = 'all') => {
  let req = supabase
      .from('posts_view')
      .select(`
      *,
      profile:user_profiles (id, username),
      salons_profile(*),
      store_owners_profile(*)
    `)
      .eq('status', 'approved');

  // Apply filtering and ordering based on filter
  switch (filter) {
    case 'recent':
      req = req.order('created_at', { ascending: false });
      break;
    case 'most-viewed':
      req = req.order('views', { ascending: false });
      break;
    case 'services':
      // Get post IDs from salon_video_categories where posts_videos is not null
      const { data: servicePostIds } = await supabase
          .from('salon_video_categories')
          .select('posts_videos')
          .not('posts_videos', 'is', null);

      const postIds = servicePostIds?.map(item => item.posts_videos) || [];

      if (postIds.length > 0) {
        req = req.in('id', postIds);
      } else {
        // If no service posts found, return empty result
        return [];
      }
      req = req.order('views', { ascending: false });
      break;
    case 'salon-products':
      req = req.not('product_id', 'is', null)
          .not('salon_profile', 'is', null)
          .order('views', { ascending: false });
      break;
    case 'store-products':
    case 'products':
      req = req.not('product_id', 'is', null)
          .not('store_id', 'is', null)
          .order('views', { ascending: false });
      break;
    case 'all':
    default:
      req = req.order('sequence', { ascending: false });
  }

  const { data, error } = await req;

  if (error) {
    throw new Error(error.message)
  }

  const posts = data?.map((d) => ({
    data: d,
    actor: d?.profile,
    own_reactions: {},
    reaction_counts: {},
  }));

  if (!posts) return [];

  return [...posts].sort((a, b) => {
    const aPinned = !!a.data.end_date;
    const bPinned = !!b.data.end_date;
    if (aPinned && !bPinned) return -1;
    if (!aPinned && bPinned) return 1;
    return 0;
  });
}

export default function useAllPosts(filter: PostFilter = 'all') {
  const queryKey = ['useAllPosts', filter]
  return useQuery({
    queryKey,
    queryFn: () => getUsersPosts(filter),
    staleTime: 5 * 60 * 1000,
    refetchOnMount: false,
  })
}